const SET_SESSION = 'scratch-gui/session/SET_SESSION';
const CLEAR_SESSION = 'scratch-gui/session/CLEAR_SESSION';

const initialState = {
    session: undefined
};

const reducer = function (state = initialState, action) {
    switch (action.type) {
    case SET_SESSION:
        return {
            ...state,
            session: action.session
        };
    case CLEAR_SESSION:
        return {
            ...state,
            session: {
                user: null
            }
        };
    default:
        return state;
    }
};

const setSession = session => ({
    type: SET_SESSION,
    session
});

const clearSession = () => ({
    type: CLEAR_SESSION
});

export {
    reducer as default,
    initialState as sessionInitialState,
    setSession,
    clearSession
};